<template>
    <div>
        <router-view class="body"/>
    </div>
</template>

<script>
    import {store_setStateValue, store_var} from "../store";

    export default {
        name: "StandAlone",
        components: {},
        created(){
            store_setStateValue(store_var.navBar_tabs_ac, [])

            store_setStateValue(store_var.navBar_menu_ac, [])
        }
    }
</script>

<style scoped>
</style>